import { reactive, ref, toRefs } from 'vue'
import axiosIns from '@axios'

const $http = axiosIns

export const $getGlossaryGroups = async () => {
  const data = ref([])

  const state = reactive({
    error: null,
    loading: false,
  })

  try {
    state.loading = true

    const res = await $http.get('sign-text-groups/')

    data.value = res.data.results
  }
  catch (e: any) {
    state.error = e
  }
  finally {
    state.loading = false
  }

  return { data, ...toRefs(state) }
}

// Time
export const $getTimezoneOffset = async (params: object) => {
  return await $http.get('timezone-offset/', { params: params })
}

export const $getS3Link = async (filepath: string) => {
  return await $http.get('/s3-link/', { params: { 'filepath': filepath }})
}

export const $splitBook = async (filename: object) => {
  return await $http.get('/split-book/', { params: filename })
}

export const $uploadPictograms = async (filename: string, group: number | null) => {
  return await $http.post('/upload-pictograms/', { filename: filename, group: group })
}

export const $taskPolling = async (taskId: string) => {
  return await $http.get('/task-polling/', { params: { task_id: taskId }})
}
